import React from 'react';

/**
 * "Already have an account? Log in" / "Don't have an account? Sign up"
 * toggle shown below the FirebaseUI login widget.
 */
export default function LoginModeSwitcher({ isSignup, locStrings, onToggle }) {
  const mode = isSignup ? 'signup' : 'login';
  const switchText = locStrings.switchtext[mode];
  const switchLink = locStrings.switchlink[mode];

  return (
    <div className="mt-3 text-center w-100 px-0">
      <p className="text-white-50 mb-0" style={{ fontSize: '1.1rem' }}>
        {`${switchText} `}
        <button
          className="btn btn-link p-0 text-white"
          style={{ textDecoration: 'underline', fontSize: '1.0rem', fontWeight: 600 }}
          onClick={() => onToggle(!isSignup)}
        >
          {switchLink}
        </button>
      </p>
    </div>
  );
}
